var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import { AppContext } from "../appContext";
import { icons } from "../icons";
var ChatTabsList = function (props) {
    var _a;
    var parentContext = useContext(AppContext);
    var chatPrefs = parentContext.chatPrefs, activeTab = parentContext.activeTab, changeActiveTab = parentContext.changeActiveTab;
    var footerTabs = (_a = chatPrefs === null || chatPrefs === void 0 ? void 0 : chatPrefs.widget) === null || _a === void 0 ? void 0 : _a.chat_footer_settings.filter(function (footer) { return footer.enable == true; });
    var getLabel = function (label) {
        if (label == "Messages")
            return "Chats";
        if (label == "Help")
            return "Help Center";
        return label;
    };
    return (_jsxs("div", __assign({ className: "chat__tabs-footer" }, { children: [_jsx("div", __assign({ className: "chat__tabs-bottom-bar" }, { children: footerTabs.map(function (footerTab) {
                    return (_jsxs("div", __assign({ className: "chat__tabs-nav-link ".concat(footerTab.tab == activeTab ? "active" : ""), onClick: function () { return changeActiveTab(footerTab.tab); } }, { children: [_jsx("div", __assign({ className: "chat__tabs-icon" }, { children: footerTab.tab == activeTab
                                    ? icons["active" + footerTab.tab]
                                    : icons[footerTab.tab] })), _jsx("span", __assign({ className: "chat__tabs-title" }, { children: getLabel(footerTab.tab) }))] })));
                }) })), !chatPrefs.isWhiteLabelEnabled && (_jsx("div", __assign({ className: "chat__powered__by-footer" }, { children: _jsx("a", __assign({ target: "_blank", href: "https://www.engagebay.com/?utm_source=powered-by&utm_medium=widget&utm_campaign=www-engagebay-com" }, { children: "Powered by EngageBay" })) })))] })));
};
export default ChatTabsList;
